import React, {
  PropsWithChildren,
  ClassAttributes,
  HTMLAttributes,
} from 'react';

export const H4 = (
  props: JSX.IntrinsicAttributes &
    ClassAttributes<HTMLHeadingElement> &
    HTMLAttributes<HTMLHeadingElement> &
    PropsWithChildren,
) => <h4 {...props} />;
